var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 17,
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.28479 0.447754C3.83099 0.447754 0.216309 4.06243 0.216309 8.51624C0.216309 12.97 3.83099 16.5847 8.28479 16.5847C12.7386 16.5847 16.3533 12.97 16.3533 8.51624C16.3533 4.06243 12.7386 0.447754 8.28479 0.447754ZM8.28479 14.971C4.72659 14.971 1.83 12.0744 1.83 8.51624C1.83 4.95804 4.72659 2.06145 8.28479 2.06145C11.843 2.06145 14.7396 4.95804 14.7396 8.51624C14.7396 12.0744 11.843 14.971 8.28479 14.971ZM11.9882 4.94997L6.67109 10.2671L4.58136 8.18543L3.4437 9.32308L6.67109 12.5505L13.1259 6.09569L11.9882 4.94997Z",
  fill: "#B7BDD1"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkIcon.c82919f5e7dc84cfd2c47062c031ef59.svg";